module.exports = __webpack_public_path__ + "img/webcam-security.fd6433c3.jpg";